const Permissions = [
    {
        "_id": "5d0df94ee98abd8a0c3796f1",
        "name": "user.create"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796f0",
        "name": "user.get"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796fb",
        "name": "user.update"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796fc",
        "name": "user.delete"
    },
    {
        "_id": "5d0af94ee98abd8a0c3796fa",
        "name": "visitor.block"
    },
    {
        "_id": "5d0af94ee98abd8a0c3796fb",
        "name": "visitor.unblock"
    },
    {
        "_id": "5d0af94ee98abd8a0c3796f2",
        "name": "visitor.view"
    },
    {
        "_id": "5d0af94ee98abd8a0c3796f1",
        "name": "bannedVisitor.view"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796f3",
        "name": "bannedWord.create"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796f4",
        "name": "bannedWord.get"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796f5",
        "name": "bannedWord.delete"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796f6",
        "name": "bannedWord.update"
    },
    {
        "_id": "5d0df94ee98abd8a0c37973e",
        "name": "chat.get"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796f7",
        "name": "chat.update"
    },
    {
        "_id": "5fd2185038c03d61c2cf44af",
        "name": "archives.get"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796f8",
        "name": "role.get"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796f9",
        "name": "role.update"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796a9",
        "name": "role.create"
    },
    {
        "_id": "5d0df94ee98abd8a0c3796b9",
        "name": "role.delete"
    },
    {
        "_id": "5d0df94ee98abd8a0c37972e",
        "name": "topic.get"
    },
    {
        "_id": "5d0df94ee98abd8a0c37971e",
        "name": "topic.update"
    },
    {
        "_id": "5d0df84ee98abd8a0c37973e",
        "name": "topic.create"
    },
    {
        "_id": "5d0df94ee98abd8a0c37974e",
        "name": "topic.delete"
    },
    {
        "_id": "1d0df94ee98abd8a0c37972e",
        "name": "prepared.get"
    },
    {
        "_id": "2d0df94ee98abd8a0c37971e",
        "name": "prepared.update"
    },
    {
        "_id": "3d0df94ee98abd8a0c37973e",
        "name": "prepared.create"
    },
    {
        "_id": "4d0df94ee98abd8a0c37974e",
        "name": "prepared.delete"
    },
    {
        "_id": "5d0df94ee98abd8a0c379705",
        "name": "welcome.get"
    },
    {
        "_id": "5d0df94ee98abd8a0c379706",
        "name": "welcome.update"
    },
    {
        "_id": "5d0df94ee98abd8a0c379707",
        "name": "welcome.create"
    },
    {
        "_id": "5d0df94ee98abd8a0c379708",
        "name": "welcome.delete"
    },
    {
        "_id": "1d0df94ee98abd8a0c379705",
        "name": "setting.get"
    },
    {
        "_id": "2d0df94ee98abd8a0c379706",
        "name": "setting.update"
    },
    {
        "_id": "3d0df94ee98abd8a0c379707",
        "name": "setting.create"
    },
    {
        "_id": "4d0df94ee98abd8a0c379708",
        "name": "setting.delete"
    },
    {
        "_id": "5d0df94ee98abd8a0c37970c",
        "name": "report.get"
    },
    {
        "_id": "5d0df94ee98abd8a0c47970c",
        "name": "report.update"
    },
    {
        "_id": "5d0df94ee98abd8a0c57970c",
        "name": "report.create"
    },
    {
        "_id": "5d0df94ee90abd8a0c57970c",
        "name": "report.delete"
    },
    {
        "_id": "5f75e40490cd480eb57de08a",
        "name": "offlineSupportRequest.get"
    },
    {
        "_id": "5f75e40e213ebc229eea72ad",
        "name": "offlineSupportRequest.update"
    },
    {
        "_id": "5f75e414f768eee426888cab",
        "name": "offlineSupportRequest.create"
    },
    {
        "_id": "5f75e418774ebe6570b37fd6",
        "name": "offlineSupportRequest.delete"
    },
    {
        "_id": "5d0df94ee98abd8a0c11970c",
        "name": "catalog.get"
    },
    {
        "_id": "5d0df94ee98abd8a0c12970c",
        "name": "catalog.update"
    },
    {
        "_id": "5d0df94ee98abd8a0c13970c",
        "name": "catalog.create"
    },
    {
        "_id": "5d0df94ee90abd8a0c14970c",
        "name": "catalog.delete"
    },
    {
        "_id": "64d65efcc0f5f2046f73d150",
        "name": "chatbot.stories.view"
    },
    {
        "_id": "64da2be12514f12132b79542",
        "name": "chatbot.stories.create"
    },
    {
        "_id": "64da2cc42514f12132b79543",
        "name": "chatbot.stories.update"
    },
    {
        "_id": "64da2d022514f12132b79544",
        "name": "chatbot.stories.delete"
    },
    {
        "_id": "64dd048839475063fc7c3336",
        "name": "chatbot.templates.view"
    },
    {
        "_id": "64dd059a39475063fc7c3337",
        "name": "chatbot.aitemplates.view"
    },
    {
        "_id": "64dde4356ba63075d6c7d69d",
        "name": "chatbot.integrations.view"
    },
    {
        "_id": "64dde47a6ba63075d6c7d69e",
        "name": "chatbot.archive.view"
    },
    {
        "_id": "64dde4c56ba63075d6c7d69f",
        "name": "chatbot.entities.view"
    },
    {
        "_id": "64e7d19495f5ff3ee8f0fcc5",
        "name": "chatbot.entities.create"
    },
    {
        "_id": "64e7d22695f5ff3ee8f0fcc6",
        "name": "chatbot.entities.update"
    },
    {
        "_id": "64e7d25595f5ff3ee8f0fcc7",
        "name": "chatbot.entities.delete"
    },
    {
        "_id": "64dde5046ba63075d6c7d6a0",
        "name": "chatbot.reports.view"
    },
    {
        "_id": "64dde5416ba63075d6c7d6a1",
        "name": "chatbot.training.view"
    },
    {
        "_id": "64dde57c6ba63075d6c7d6a2",
        "name": "chatbot.usersegments.view"
    },
    {
        "_id": "64ebc522bb7be9336371f20c",
        "name": "chatbot.usersegments.create"
    },
    {
        "_id": "64ebc578bb7be9336371f20d",
        "name": "chatbot.usersegments.update"
    },
    {
        "_id": "64ebc5abbb7be9336371f20e",
        "name": "chatbot.usersegments.delete"
    },
    {
        "_id": "64ee652152c6702cbc59507f",
        "name": "integrations.view"
    },
    {
        "_id": "64ee661452c6702cbc595080",
        "name": "integrations.whatsapp.view"
    },
    {
        "_id": "64ee661452c6702cbc595081",
        "name": "integrations.instagram.view"
    },
    {
        "_id": "64ef2378ee56fd518405a0df",
        "name": "integrations.telegram.view"
    },
    {
        "_id": "64ef27fdee56fd518405a0e0",
        "name": "integrations.create"
    },
    {
        "_id": "64ef2e35ee56fd518405a0e1",
        "name": "trigers.view"
    },
    {
        "_id": "64f03ed81f7a532728c9219e",
        "name": "trigers.create"
    },
    {
        "_id": "64f03ed81f7a532728c9219f",
        "name": "trigers.update"
    },
    {
        "_id": "64f70a1b5246194782b2ed17",
        "name": "trigers.delete"
    },
    {
        "_id": "64f4f9f5160d9635b1cf77d8",
        "name": "visitor.list.view"
    },
    {
        "_id": "64f50a2c160d9635b1cf77d9",
        "name": "visitor.delete"
    },
    {
        "_id": "64f50b06160d9635b1cf77da",
        "name": "visitor.excel"
    },
    {
        "_id": "64f50c13160d9635b1cf77db",
        "name": "visitor.update"
    },
    {
        "_id": "64f50c13160d9635b1cf77db",
        "name": "billing.read"
    },
    {
        "_id": "66421d039e90f7019a805e47",
        "name": "calendar.read"
    },
    {
        "_id": "66421cfd7a8bb2621a61f442",
        "name": "calendar.create"
    },
    {
        "_id": "66421cf7960d653c7bdf4b78",
        "name": "calendar.update"
    },
    {
        "_id": "66421cf0268d973f18e6e56c",
        "name": "calendar.delete"
    },
    {
        "_id": "6642116aad3836cb889d7dbc",
        "name": "task.read"
    },
    {
        "_id": "679771a7e0faca3e99d7b3bc",
        "name": "task.detailRead"
    },
    {
        "_id": "66437b2cde9b51d7763ae181",
        "name": "mail.read"
    },
    {
        "_id": "66437b34698c473ecf241434",
        "name": "mail.create"
    },
    {
        "_id": "66437b3eeb9f0dfc02ef6918",
        "name": "mail.update"
    },
    {
        "_id": "66437b44d3ab1420ff321235",
        "name": "mail.delete"
    },
    {
        "_id": "664afb31a5f33fc81c96ed6d",
        "name": "integrations.messenger.view"
    },
    {
        "_id": "6f1df94ee98abd8a0c379801",
        "name": "table.get"
    },
    {
        "_id": "6f1df94ee98abd8a0c379802",
        "name": "table.create"
    },
    {
        "_id": "6f1df94ee98abd8a0c379803",
        "name": "table.update"
    },
    {
        "_id": "6f1df94ee98abd8a0c379804",
        "name": "table.delete"
    },
    {
        "_id": "6f1df94ee98abd8a0c379805",
        "name": "automation.get"
    },
    {
        "_id": "6f1df94ee98abd8a0c379806",
        "name": "automation.create"
    },
    {
        "_id": "6f1df94ee98abd8a0c379807",
        "name": "automation.update"
    },
    {
        "_id": "6f1df94ee98abd8a0c379808",
        "name": "automation.delete"
    },
    {
        "_id": "6f1df94ee98abd8a0c379809",
        "name": "form.get"
    },
    {
        "_id": "6f1df94ee98abd8a0c379810",
        "name": "form.create"
    },
    {
        "_id": "6f1df94ee98abd8a0c379811",
        "name": "form.update"
    },
    {
        "_id": "6f1df94ee98abd8a0c379812",
        "name": "form.delete"
    },
    {
        "_id": "69848c3a4cf181b6786d07ea",
        "name": "form.updateResponse"
    },
    {
        "_id": "6f1df94ee98abd8a0c379813",
        "name": "drive.get"
    },
    {
        "_id": "6f1df94ee98abd8a0c379814",
        "name": "drive.create"
    },
    {
        "_id": "6f1df94ee98abd8a0c379815",
        "name": "drive.update"
    },
    {
        "_id": "6f1df94ee98abd8a0c379816",
        "name": "drive.delete"
    },
    {
        "_id": "6f1df94ee98abd8a0c379817",
        "name": "tags.get"
    },
    {
        "_id": "6f1df94ee98abd8a0c379818",
        "name": "tags.create"
    },
    {
        "_id": "6f1df94ee98abd8a0c379819",
        "name": "tags.update"
    },
    {
        "_id": "6f1df94ee98abd8a0c379820",
        "name": "tags.delete"
    },
    {
        "_id": "684accd2f81ed0a2d313ac2c",
        "name": "voice-agent.create",
    },
    {
        "_id": "684accd9bcb30ccf52807e06",
        "name": "voice-agent.delete",
    },
    {
        "_id": "684accdc00312a90d398e3b1",
        "name": "voice-agent.update",
    },
    {
        "_id": "684acce17bda9cfb45645c8b",
        "name": "voice-agent.get",
    }
]



const PermissionDescriptions = (that) => {
    return {
        "voice-agent": {
            "create": "Oluşturma Aksiyonları",
            "get": "Görüntüleme",
            "update": "Güncelleme Aksiyonları",
            "delete": "Silme Aksiyonları"
        },
        "user": {
            "create": "Kullanıcı Oluşturma",
            "get": "Kullanıcı Görüntüleme",
            "update": "Kullanıcı Güncelleme",
            "delete": "Kullanıcı Silme"
        },
        "visitor": {
            "block": "Ziyaretçi Engelleme",
            "unblock": "Ziyaretçi Engeli Kaldırma",
            "view": "Ziyaretçi Görüntüleme",
            "delete": "Ziyaretçi Silme",
            "excel": "Ziyaretçi Excel İşlemleri",
            "update": "Ziyaretçi Güncelleme",
            "list": {
                "view": "Ziyaretçi Listesi Görüntüleme"
            }
        },
        "bannedVisitor": {
            "view": "Yasaklı Ziyaretçileri Görüntüleme"
        },
        "billing": {
            "read": "Fatura Okuma"
        },
        "bannedWord": {
            "create": "Yasaklı Kelime Oluşturma",
            "get": "Yasaklı Kelimeleri Görüntüleme",
            "update": "Yasaklı Kelime Güncelleme",
            "delete": "Yasaklı Kelime Silme"
        },
        "chat": {
            "get": "Chat Görüntüleme",
            "update": "Chat Güncelleme",
            "delete": "Chat Silme"
        },
        "archives": {
            "get": "Arşiv Görüntüleme"
        },
        "role": {
            "get": "Rol Görüntüleme",
            "update": "Rol Güncelleme",
            "create": "Rol Oluşturma",
            "delete": "Rol Silme"
        },
        "topic": {
            "get": "Konu Görüntüleme",
            "update": "Konu Güncelleme",
            "create": "Konu Oluşturma",
            "delete": "Konu Silme"
        },
        "prepared": {
            "get": "Hazır İçerikleri Görüntüleme",
            "update": "Hazır İçerik Güncelleme",
            "create": "Hazır İçerik Oluşturma",
            "delete": "Hazır İçerik Silme"
        },
        "welcome": {
            "get": "Hoş Geldiniz Mesajı Görüntüleme",
            "update": "Hoş Geldiniz Mesajı Güncelleme",
            "create": "Hoş Geldiniz Mesajı Oluşturma",
            "delete": "Hoş Geldiniz Mesajı Silme"
        },
        "setting": {
            "get": "Ayarlar Görüntüleme",
            "update": "Ayarlar Güncelleme",
            "create": "Ayarlar Oluşturma",
            "delete": "Ayarlar Silme"
        },
        "report": {
            "get": "Rapor Görüntüleme",
            "update": "Rapor Güncelleme",
            "create": "Rapor Oluşturma",
            "delete": "Rapor Silme"
        },
        "offlineSupportRequest": {
            "get": "Çevrimdışı Destek Talebi Görüntüleme",
            "update": "Çevrimdışı Destek Talebi Güncelleme",
            "create": "Çevrimdışı Destek Talebi Oluşturma",
            "delete": "Çevrimdışı Destek Talebi Silme"
        },
        "catalog": {
            "get": "Katalog Görüntüleme",
            "update": "Katalog Güncelleme",
            "create": "Katalog Oluşturma",
            "delete": "Katalog Silme"
        },
        "chatbot": {
            "stories": {
                "view": "Hikayeler Görüntüleme",
                "create": "Hikayeler Oluşturma",
                "update": "Hikayeler Güncelleme",
                "delete": "Hikayeler Silme"
            },
            "templates": {
                "view": "Şablonlar Görüntüleme"
            },
            "aitemplates": {
                "view": "AI Şablonlar Görüntüleme"
            },
            "integrations": {
                "view": "Entegrasyonlar Görüntüleme"
            },
            "archive": {
                "view": "Arşiv Görüntüleme"
            },
            "entities": {
                "view": "Varlıklar Görüntüleme",
                "create": "Varlıklar Oluşturma",
                "update": "Varlıklar Güncelleme",
                "delete": "Varlıklar Silme"
            },
            "reports": {
                "view": "Raporlar Görüntüleme"
            },
            "training": {
                "view": "Eğitimler Görüntüleme"
            },
            "usersegments": {
                "view": "Kullanıcı Segmentleri Görüntüleme",
                "create": "Kullanıcı Segmentleri Oluşturma",
                "update": "Kullanıcı Segmentleri Güncelleme",
                "delete": "Kullanıcı Segmentleri Silme"
            }
        },
        "integrations": {
            "create": "Entegrasyon Oluşturma",
            "view": "Entegrasyonlar Görüntüleme",
            "whatsapp": {
                "view": "Whatsapp Entegrasyonları Görüntüleme",
            },
            "instagram": {
                "view": "Instagram Entegrasyonları Görüntüleme",
            },
            "telegram": {
                "view": "Telegram Entegrasyonları Görüntüleme",
            },
            "messenger": {
                "view": "Messenger Entegrasyonları Görüntüleme",
            }
        },
        "trigers": {
            "view": "Tetikler Görüntüleme",
            "create": "Tetikler Oluşturma",
            "update": "Tetikler Güncelleme",
            "delete": "Tetikler Silme"
        },
        "calendar": {
            "read": "Takvim Görüntüleme",
            "create": "Takvim Oluşturma",
            "update": "Takvim Güncelleme",
            "delete": "Takvim Silme"
        },
        "task": {
            "read": "Görev Görüntüleme",
            "detailRead": "Görev Detay Görüntüleme",
            "create": "Görev Oluşturma",
            "update": "Görev Güncelleme",
            "delete": "Görev Silme"
        },
        "mail": {
            "read": "Mail Görüntüleme",
            "create": "Mail Oluşturma",
            "update": "Mail Güncelleme",
            "delete": "Mail Silme"
        },
        "table": {
            "get": "Tablo Görüntüleme",
            "create": "Tablo Oluşturma",
            "update": "Tablo Güncelleme",
            "delete": "Tablo Silme"
        },
        "automation": {
            "get": "Otomasyon Görüntüleme",
            "create": "Otomasyon Oluşturma",
            "update": "Otomasyon Güncelleme",
            "delete": "Otomasyon Silme"
        },
        "form": {
            "get": "Form Görüntüleme",
            "create": "Form Oluşturma",
            "update": "Form Güncelleme",
            "delete": "Form Silme",
            "updateResponse": "Form Yanıtlarını Düzenleme"
        },
        "drive": {
            "get": "Drive Görüntüleme",
            "create": "Drive Oluşturma",
            "update": "Drive Güncelleme",
            "delete": "Drive Silme"
        },
        "tags": {
            "get": "Etiket Görüntüleme",
            "create": "Etiket Oluşturma",
            "update": "Etiket Güncelleme",
            "delete": "Etiket Silme"
        }
    }
}

const getPermissionDescription = (name) => {
    const descriptions = PermissionDescriptions();
    const cloneName = `${name}`
    const [entity, subEntity, action] = cloneName.split('.');
    console.log("getPermissionDescription", name, { entity, subEntity, action });
    return action ? descriptions[entity][subEntity][action] : descriptions[entity][subEntity];
};

// Entity adlarını dönüştüren fonksiyon - eklemek istediğiniz yeni entity adlarını buraya ekleyin
const getModuleName = (moduleKey) => {
    const moduleMap = {
        'voice-agent': 'Sesli Ajan',
        'user': 'Kullanıcılar',
        'visitor': 'Ziyaretçiler',
        'bannedWord': 'Yasaklı Kelime',
        'chat': 'Sohbet',
        'archives': 'Arşivler',
        'role': 'Roller',
        'topic': 'Konular',
        'prepared': 'Hazır İçerik',
        'welcome': 'Karşılama Mesajları',
        'setting': 'Ayar',
        'report': 'Raporlar',
        'offlineSupportRequest': 'Çevrimdışı Destek Talepleri',
        'catalog': 'Kataloglar',
        'chatbot': 'Chatbot',
        'integrations': 'Entegrasyonlar',
        'trigers': 'Tetikleyici',
        'calendar': 'Takvim',
        'task': 'Görev',
        'mail': 'Mail',
        'table': 'Tablo',
        'automation': 'Otomasyon',
        'form': 'Form',
        'drive': 'Drive',
        'tags': 'Etiketler',
        'billing': 'Faturalar',
        'bannedVisitor': 'Engellenen Ziyaretçiler',
    };

    return moduleMap[moduleKey] || moduleKey.charAt(0).toUpperCase() + moduleKey.slice(1);
};

const getSubEntityName = (subEntity) => {
    const subEntityMap = {
        "basic-actions": "Basit Aksiyonlar",
        // Chatbot
        'stories': 'Hikayeler',
        'templates': 'Şablonlar',
        'aitemplates': 'AI Şablonlar',
        'integrations': 'Entegrasyonlar',
        'archive': 'Arşiv',
        'entities': 'Varlıklar',
        'reports': 'Raporlar',
        'training': 'Bot Eğitimi',
        'usersegments': 'Kullanıcı Bölümleri',

        // Integrations
        'whatsapp': 'WhatsApp',
        'telegram': 'Telegram',
        'instagram': 'Instagram',
        'messenger': 'Messenger',

        // Visitor
        'list': 'Ziyaretçi Listesi',
        'block': 'Engelleme İşlemleri',
        'unblock': 'Engel Kaldırma',
        'excel': 'Excel İşlemleri',

        // Genel
        'get': 'Görüntüleme',
        'create': 'Oluşturma',
        'update': 'Güncelleme',
        'delete': 'Silme',
        'view': 'Görüntüleme',
        'updateResponse': 'Form Yanıtlarını Düzenleme',
    };

    return subEntityMap[subEntity] || subEntity.charAt(0).toUpperCase() + subEntity.slice(1);
};


const groupPermissions = (permissions) => {
    const groupedPermissions = permissions.reduce((acc, permission) => {
        const [entity, subEntity, action] = permission.name.split('.');
        const _subEntity = action ? subEntity : "basic-actions";
        const _action = action ? action : subEntity;

        if (!acc[entity]) {
            acc[entity] = {
                module: getModuleName(entity),
                key: entity,
                items: {}
            };
        }

        acc[entity].items[_subEntity] = {
            name: getSubEntityName(_subEntity),
            key: _subEntity,
            actions: [
                ...acc[entity].items[_subEntity]?.actions || [],
                {
                    isViewPermission: ['read', 'get', 'view'].includes(_action),
                    name: permission.name,
                    _id: permission._id
                }
            ],
        };
        return acc;
    }, {});

    return Object.values(groupedPermissions).map(module => ({
        module: module.module,
        key: module.key,
        items: Object.values(module.items).map(item => {
            const viewActions = item.actions.filter(action => action.isViewPermission);
            const actions = item.actions.filter(action => !action.isViewPermission);
            return {
                ...item,
                actions: [
                    ...viewActions,
                    ...actions,
                ]
            }
        })
    }));
}


export {
    Permissions,
    getPermissionDescription,
    getModuleName,
    getSubEntityName,
    groupPermissions,
    PermissionDescriptions,
}
